import { noForwardProps } from '@apeiron/temp'
import { Box, styled, Typography } from '@mui/material'
import { ReactNode } from 'react'

const LabelOverlay = styled(Box, noForwardProps)<LabelOverlayProps>`
  background-color: #1b1b20;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
  width: 95.5%;
  ${props =>
    props.__smallCard
      ? `
        bottom: 3.5%;
        height: 15%;
      `
      : `
        bottom: 3%;
        height: 15%;
      `}
`

const getBackground = (variant?: 'red' | 'basic') => {
  switch (variant) {
    case 'red':
      return `linear-gradient(
        90deg,
        rgba(234, 67, 2, 0.2) 0%,
        rgba(234, 67, 2, 0.7) 25%,
        rgba(234, 67, 2, 1) 50%,
        rgba(234, 67, 2, 0.7) 75%,
        rgba(234, 67, 2, 0.2) 100%
      )`
    case 'basic':
    default: {
      return `linear-gradient(
        90deg,
        rgba(0, 92, 215, 0) 0%,
        rgba(0, 92, 215, 0.7) 25%,
        rgba(0, 92, 215, 1) 50%,
        rgba(0, 92, 215, 0.7) 75%,
        rgba(0, 92, 215, 0) 100%
      )`
    }
  }
}

const Label = styled(Typography, noForwardProps)<LabelProps>`
  align-items: center;
  background: ${props => getBackground(props.__variant)};
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
  ${props =>
    props.__smallCard
      ? `
        font-size: 12px;
        font-weight: 500;
      `
      : `
        font-size: 16px;
        font-weight: 700;
      `}
`

type LabelOverlayProps = {
  __smallCard: boolean
}

type LabelProps = LabelOverlayProps & {
  __variant?: Props['variant']
}

const ApostleCardOverlay = ({
  children,
  smallCard = false,
  variant = 'basic'
}: Props) => {
  return (
    <LabelOverlay __smallCard={smallCard}>
      <Label __variant={variant} __smallCard={smallCard}>
        {children}
      </Label>
    </LabelOverlay>
  )
}

type Props = {
  variant?: 'red' | 'basic'
  smallCard?: boolean
  children: ReactNode
}

export default ApostleCardOverlay
